// Module
var code = "<button class=\"btn\" ng-click=\"$ctrl.select()\" ng-class=\"[$ctrl.class, $ctrl.isEmpty() ? 'btn-default' : 'btn-info']\"> <i class=\"fa\" ng-class=\"'fa-' + $ctrl.icon\" ng-if=\"$ctrl.icon\"></i> {{ $ctrl.label }} </button> ";
// Exports
export default code;